export default {
  // 模块名称
  workGroup: {
    // 按钮类
    button: {
      add: 'Add',
      batchDel: 'Batch delete',
      reset: 'Reset',
      query: 'Query',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      setPermission: 'Permission settings',
      relation: 'Account associated',
      back: 'Back'
    },
    // 文字标签类
    label: {
      accountGroup: 'Account group name',
      remark: 'Remark',
      creator: 'Creator',
      createTime: 'Creation time',
      lastModifyTime: 'Last modified',
      operations: 'Operations',
      deviceName: 'Name',
      deviceType: 'Type',
      showPermission: 'Show',
      operatePermission: 'Operate',
      functionPermission: 'Functional permissions',
      areaDevicePermission: 'Regional device permissions'
    },
    // 提示类
    placeholder: {
      accountGroup: 'Enter account group name',
      remark: 'Enter remark'
    },
    // 消息类
    message: {
      accountGroup: 'Enter account group name',
      remark: 'Enter remark',
      less30: 'Account group name is 4 to 30 characters',
      formatAccount: 'Account group name only includes letters, numbers, Chinese characters, underscores',
      less200: 'Remarks is less than 200 characters',
      setSuccess: 'Account group setting account is successful',
      deltips: 'This will permanently delete the selected account group. continue?',
      batchDel: 'The account group was successfully deleted in batches',
      selecttips: 'Please select the account group you want to delete',
      delSuccess: 'Delete successfully',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      setPermissionSuccess: 'Account group setting permission is successful'
    },
    // 标题类
    title: {
      warn: 'Warning',
      resetPW: 'Reset password',
      addAccountGroup: 'Add account group',
      editAccountGroup: 'Edit account group',
      relations: 'The relationship of account and account group',
      functionPermission: 'Functional permissions',
      selectedAccount: 'Selected account',
      selectableAccount: 'Optional account'
    }
  }
}